<template>
  <vs-wrapper>
    <span v-if="errorMessage" ref="alertBanner">
      <vs-alert type="error">
        {{ errorMessage }}
      </vs-alert>
    </span>
  </vs-wrapper>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex-composition-helpers'
import VsAlert from '@/components/vision/VsAlert.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'

const alertBanner = ref()
const store = useStore()

const ticketsError = computed(() => store.getters['tickets/getError'])

const errorMessage = computed(() => {
  if (ticketsError.value && ticketsError.value.response && ticketsError.value.response.data) {
    return (
      formatErrors(ticketsError.value.response.data.detail) ||
      formatErrors(ticketsError.value.response.data.errors) ||
      'Error saving Job'
    )
  }

  return false
})

const formatErrors = (errors) => {
  if (typeof errors === 'object') {
    return Object.entries(errors)
      .flatMap(([_, messages]) => messages)
      .join(', ')
  }
  return errors
}

watch(errorMessage, (newValue) => {
  if (newValue === false) {
    store.commit('tickets/CLEAR_TICKETS_ERROR')
  }
})

watch(alertBanner, (newValue) => {
  if (newValue) {
    newValue.scrollIntoView({ behavior: 'smooth' })
  }
})
</script>
